import {
    ADD_NEWMERCHANT_FAILED, ADD_NEWMERCHANT_SUCCESS, ADD_NEWMERCHANT_LOADING, ADD_NEWMERCHANT_REMOVE
} from "../types";

const initialState = {
    loading: false,
    error: null,
    status: null,
    OnlineRegister: null,
    request: null,
};

export const merchantOnlineRegisterReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; status: any; error: any, request: any }
) => {
    switch (action.type) {
        case ADD_NEWMERCHANT_LOADING:
            return {
                ...state,
                loading: true,
            };
        case ADD_NEWMERCHANT_SUCCESS:
            return {
                ...state,
                loading: false,
                OnlineRegister: action.payload,
                status: action.status,
                error: null,
                request: action.request
            };
        case ADD_NEWMERCHANT_FAILED:
            return {
                ...state,
                loading: false,
                status: action.status,
                error: action.error,
                request: action.request

            };
        case ADD_NEWMERCHANT_REMOVE:
            return {
                loading: false,
                error: null,
                status: null,
                OnlineRegister: null,
                request: null
            }

        default:
            return state;
    }
};

